import React, { useRef } from 'react'
import { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, countries, deepClone, generateCircleDot, generateCircleDotCR, getColorForDifficulty, getCountryName, getCurrNex, updateNexFDB } from '../utils'
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import Loading from './Loading';
import LoadingBar from './LoadingBar';
import { useDispatch, useSelector } from 'react-redux';
import { addKeywords, addThemes, updateProjects } from '../Redux/projectsSlice';
import FilterListIcon from '@mui/icons-material/FilterList';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { doc, setDoc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { redNex } from '../Redux/nexSlice';
import pushKP from '../media/push-kp.png'
import createKP from '../media/create-kp.png'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import KRSerpLoading from './KRSerpLoading'
import InfoIcon from '@mui/icons-material/Info';
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import CloseIcon from '@mui/icons-material/Close';
import InterestChart from './InterestChart';
import KeywordDifficultyChart from './KeywordDifficultyChart';
import NicheMarketPotentialScore from './NicheMarketPotentialScore';
import TextureIcon from '@mui/icons-material/Texture';


function KeywordResearch({ listn, nexListn, _nex, fr }) {
  const [inputKeyword, setInputKeyword] = useState('')
  const [location, setLocation] = useState('')
  const [incWords, setIncWords] = useState([])
  const [excWords, setExcWords] = useState([])
  const [data, setData] = useState([])
  const [originalData, setOriginalData] = useState([])
  const [vList, setVList] = useState(50)
  const [ids, setIds] = useState([])
  const [selectedKeywords, setSelectedKeywords] = useState([])
  const [sortOrder, setSortOrder] = useState('')
  const [interestData, setInterestData] = useState(null)

  const [isLoading, setIsLoading] = useState(false)
  const [matchType, setMatchType] = useState(null)
  const [noData, setNoData] = useState(false)

  const [projectName, setProjectName] = useState('')
  const [theme, setTheme] = useState('')
  const [themeOperationType, setThemeOperationType] = useState('')

  const [newProjectName, setNewProjectName] = useState('')
  const [newThemeName, setNewThemetName] = useState('')
  const [newThemeNameExistingProject, setNewThemetNameExistingProject] = useState('')

  const [pushed, setPushed] = useState(false)
  const [pushedTo, setPushedTo] = useState([])
  const [isPush, setIsPush] = useState(false)
  const [isProject, setIsProject] = useState(false)

  const [intentlessData, setIntentlessData] = useState([])

  const [addToProjectSelection, setAddToProjectSelection] = useState(false)

  const [showPopup, setShowPopup] = useState(false);
  const [showPushPopup, setShowPushPopup] = useState(false);

  const [showIntentFilter, setShowIntentFilter] = useState(false);
  const [selectedIntent, setSelectedIntent] = useState('all');

  const [createProjectActive, setCreateProjectActive] = useState(false)
  const [pushToProjectActive, setPushToProjectActive] = useState(false)

  const [isProjectCreated, setIsProjectCreated] = useState(false)
  const [isPushedToProject, setIsPushedToProject] = useState(false)

  const [updatesDate, setUpdatesDate] = useState(null)

  const [prevKeyword, setPrevKeyword] = useState(null)

  const [prevNex, setPrevNex] = useState(null)

  const [noInput, setNoInput] = useState(false)
  const [noSelection, setNoSelection] = useState(false)

  const [pushNoPRojectName, setPushNoProjectName] = useState(false)
  const [pushNoThemeName, setPushNoThemetName] = useState(false)
  const [pushNoSelectedTheme, setPushNoSelectedTheme] = useState(false)

  const [createNoProjectName, setCreateNoProjectName] = useState(false)
  const [createNoThemeName, setCreateNoThemeName] = useState(false)

  const [showKeywordDifficultyScoreInfo, setShowKeywordDifficultyScoreInfo] = useState(false)
  const [showMarketPotentialInfo, setShowMarketPotentialInfo] = useState(false)
  const [showInterestLevelInfo, setShowInterestLevelInfo] = useState(false)


  const [serpLayer, setSerpLayer] = useState(false)
  const [serpData, setSerpData] = useState([])
  const [serpLoading, setSerpLoading] = useState(false)
  const [serpKeyword, setSerpKeyword] = useState('')
  const [serpNoData, setSerpNoData] = useState(false)
  const [kRSerpLoadingP, setKRSerpLoadingP] = useState(false)


  const [cpcInfo, setCpcInfo] = useState(false)
  const [volumeInfo, setVolumeInfo] = useState(false)
  const [difficultyInfo, setDifficultyInfo] = useState(false)
  const [intentInfo, setIntentInfo] = useState(false)

  const [showDifficultyFilter, setShowDifficultyFilter] = useState(false)
  const [diffMax, setDiffMax] = useState(undefined)
  const [diffMin, setDiffMin] = useState(undefined)
  const [dMinFilterData, setDMinFilterData] = useState(undefined)
  const [dMaxFilterData, setDMaxFilterData] = useState(undefined)

  // const [filteredByVolume, setFilteredByVolume] = useState(null);
  const [vMax, setVMax] = useState(undefined)
  const [vMin, setVMin] = useState(undefined)
  const [vMinFilterData, setVMinFilterData] = useState(undefined)
  const [vMaxFilterData, setVMaxFilterData] = useState(undefined)
  const [showVolumeFilter, setShowVolumeFilter] = useState(false)

  const [iwAltered, setIwAltered] = useState(false)
  const [ewAltered, setEwAltered] = useState(false)


  const [width, setWidth] = useState(window.innerWidth);

  const projects = useSelector(state=> state.projects.projects)
  const user = useSelector(state=> state.user.user)
  const nx = useSelector(state=> state.nex.nex)

  const dispatch = useDispatch()



  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  // useEffect(()=> {
  //   if(_nex) {
  //     setPrevNex(_nex)
  //   }
  // }, [_nex])


  const togglePopup = () => {
    setShowPopup(!showPopup);
    setCreateProjectActive(!createProjectActive)
    setNewProjectName('')
    setNewThemetName('')
    setTheme('')
    setNewThemetNameExistingProject('')
    setCreateNoProjectName(false)
    setCreateNoThemeName(false)
  };

  const togglePushPopup = () => {
    setPushNoProjectName(false)
    setPushNoSelectedTheme(false)
    setPushNoThemetName(false)
    setShowPushPopup(!showPushPopup);
    setPushToProjectActive(!pushToProjectActive)
    setNewProjectName('')
    setNewThemetName('')
    setTheme('')
    setNewThemetNameExistingProject('')
    setProjectName('')
    setThemeOperationType('')
  };


  const waitForData = () => {
    setTimeout(() => {
      if (data.length === 0) {
        setNoData(true)
        setIsLoading(false)
      }
    }, 60000);
  };



  useEffect(()=> {
    if(originalData.length > 0 && data.length === 0) {
      setNoData(true)
    }
  }, [data])


  useEffect(()=> {
    if(data.length !== 0) {
      setNoData(false)
    }
  }, [data])


  useEffect(()=> {
    let timeoutId
    if(isPushedToProject) {
      timeoutId = setTimeout(()=> {
        setIsPushedToProject(false)
        setShowPushPopup(false)
        setNewProjectName('')
        setNewThemetName('')
        setTheme('')
      }, 3000)
    }

    return () => clearTimeout(timeoutId)
  }, [isPushedToProject])

  useEffect(()=> {
    let timeoutId
    if(isProjectCreated) {
      timeoutId = setTimeout(()=> {
        setIsProjectCreated(false)
        setNewThemetName('')
        setNewThemetName('')
        setTheme('')
      }, 3000)
    }

    return () => clearTimeout(timeoutId)
  }, [isProjectCreated])


  useEffect(()=> {
    if(selectedKeywords.length === 0) {
      setIsPush(false)
      setIsProject(false)
    }
  }, [selectedKeywords])


  function getData() {
    if (inputKeyword !== '' && location !== '') {
      setNoInput(false);
      setNoSelection(false);
  
      // const updateAnalytics = async () => {
      //   const tool = window.location.pathname.split('/').pop();
      //   let tools = deepClone(user.analytics?.toolsUsage ?? {});
  
      //   // Ensure the tool exists in toolsUsage
      //   if (tools[tool] !== undefined) {
      //     tools[tool] += 1;
      //   } else {
      //     tools[tool] = 1;
      //   }
  
      //   // Ensure toolsUsage is defined before updating Firestore
      //   if (Object.keys(tools).length > 0 && user.id) {
      //     await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
      //   }
      // };

      const updateAnalytics = async () => {
        const tool = window.location.pathname.split('/').pop();
        let tools = deepClone(user.analytics.toolsUsage);
    
        if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
            tools[tool] = 1;
        } else {
            tools[tool] = Number(tools[tool]) + 1;
        }
    
        await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
      };
  
      setPrevKeyword(inputKeyword);
      setIsLoading(true);
      setData([]);
      setInterestData(null);
      setOriginalData([])
      setNoData(false);
      setSelectedIntent('all');
      setIds([]);
      setSelectedKeywords([]);
      setIncWords([]);
      setExcWords([]);

      setVMax(undefined)
      setVMin(undefined)
      setVMaxFilterData(undefined)
      setVMinFilterData(undefined)

      setDiffMax(undefined)
      setDiffMin(undefined)
      setDMaxFilterData(undefined)
      setDMinFilterData(undefined)

      setUpdatesDate(false)
      
      // waitForData();

      fetch(`${base}/res`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            type: 'kr',
            keyword: inputKeyword.trim().replaceAll('-', ' '),
            location: location,
            userId: user.id
          })
        }).then(res=> res.json()).then(rawData=> {
          // let cleanData = Object.values(data?.reduce((obj, k)=> {
          //   if(!obj[k.keyword]) {
          //     obj[k.keyword] = k
          //   }
          //   return obj
          // })) || []
          if(rawData?.error) {
            // setData([rawData])
            setData([])
            setNoData(true)
            setIsLoading(false)
            return
          }

          if(rawData[0]?.error) {
            // setData([rawData])
            setData([])
            setNoData(true)
            setIsLoading(false)
            return
          }

          if(rawData?.keywords.length == 0) {
            // setData([rawData])
            setData([])
            setNoData(true)
            setIsLoading(false)
            return
          }
          setData(rawData.keywords)
          setOriginalData(rawData.keywords)
          setInterestData(rawData.interest)
          setUpdatesDate(rawData.ld)
          setPushedTo([])
          setIsLoading(false)
          updateAnalytics()
          // nexListn()
          dispatch(redNex(nx))
          // updateNexFDB(prevNex)
          // setPrevNex(prev => prev - 1)
        })
      } else {
        if(inputKeyword.trim() === '') setNoInput(true)
        if(location.trim() === '') setNoSelection(true)
      }
  }



  const nxtP = () => {
    setVList(prev=> prev + 50)
  }



  const uSelection = (id, keyword, volume, cpc, intent, difficulty) => {
    setIds(prev=> {
      if(ids.includes(keyword)) {
        return prev.filter(k=> k !== keyword)
      } else {
        return [...prev, keyword]
      }
    })

    setSelectedKeywords(prev=> {
      let arr = prev.filter(k=> k.keyword === keyword)

      if(arr.length === 0) {
        return [...prev, {
          keyword: keyword,
          volume: volume,
          cpc: cpc,
          intent: intent,
          difficulty: difficulty
        }]
      }

      if(arr.length > 0) {
        return prev.filter(k=> k.keyword !== keyword)
      }
    })
  }


  const selectAll = () => {
    if(ids.length !== data.length){
      let arr = []

      for(let i = 0; i < data.length; i++) {
        arr.push(data[i].keyword)
      }

      setIds(arr)

      let arr2 = []

      for(let j = 0; j < data.length; j++) {
        arr2.push({
          keyword: data[j].keyword,
          volume: data[j].volume,
          cpc: data[j].cpc,
          intent: data[j].intent,
          difficulty: data[j].difficulty
        })
      }

      setSelectedKeywords(arr2)
    }

    if(ids.length === data.length) {
      setIds([])
      setSelectedKeywords([])
    }
  }

  const sorting = (sortProp) => {
    const newSortOrder = sortOrder === '' || sortOrder === 'asc' ? 'desc' : 'asc';
    setSortOrder(newSortOrder);
  
    const sorted = [...data].sort((a, b) => {
      let x, y;
      if (sortProp === 'cpc') {
        x = parseFloat(a[sortProp]?.replace(/[$,]/g, ''));
        y = parseFloat(b[sortProp]?.replace(/[$,]/g, ''));
      } else {
        x = parseFloat(a[sortProp]?.replace(/,/g, ''));
        y = parseFloat(b[sortProp]?.replace(/,/g, ''));
      }
      return newSortOrder === 'asc' ? x - y : y - x;
    });
  
    setData(sorted);
  }

  // const updateProjectsObj = async (yProjects) => {
  //   try {
  //     // Create a reference to the document
  //     const docRef = doc(db, 'users', user.id);
      
  //     // Use setDoc with merge option to update only the projects field

  //     setDoc(docRef, { projects: yProjects }, { merge: true });
      
  //   } catch (error) {
  //     console.error('Error updating projects:', error);
  //   }
  // };


  const createProject = async () => {
    if (newProjectName.trim() !== '' && newThemeName.trim() !== '') {
      setCreateNoProjectName(false);
      setCreateNoThemeName(false);
  
      // const sameName = projects.find(
      //   (x) => x.name?.toLowerCase() === newProjectName?.toLowerCase() && x.type === 'keyword'
      // );
  
      // if (sameName) {
      //   window.alert("You've already created a project with the same name for 'keyword' project type. Please choose a different name for your new project.");
      //   return;
      // }

      const sameName = projects.find((x) => {
        // Ensure x.name and newProjectName are strings before calling toLowerCase()
        const name = typeof x.name === 'string' ? x.name.toLowerCase() : '';
        const newName = typeof newProjectName === 'string' ? newProjectName.toLowerCase() : '';
      
        return name === newName && x.type === 'keyword';
      });
      
      if (sameName) {
        window.alert("You've already created a project with the same name for 'keyword' project type. Please choose a different name for your new project.");
        return;
      }

      const rawKeywords = new Set();
      const sanitizedData = selectedKeywords.filter(item => {
        const isDuplicate = rawKeywords.has(item.keyword);
        if (!isDuplicate) {
          rawKeywords.add(item.keyword);
          return true;
        }
        return false;
      });
  
      const regex = /^[a-zA-Z0-9\s]*$/;
      if (regex.test(newProjectName.trim())) {
        let firstTheme = {
          name: newThemeName,
          keywords: sanitizedData,
        };
  
        let updatedProjects = [
          ...projects,
          { name: newProjectName.trim(), type: 'keyword', themes: [firstTheme], n: projects.length + 1 },
        ];
  
        // Dispatch state update
        dispatch(updateProjects(updatedProjects));
  
        // After dispatch completes, update Firestore
        try {
          // Optionally wait for the state update to reflect if needed  
          // Update the Firestore document
          // await new Promise((resolve) => setTimeout(resolve, 3000))
          // await updateProjectsObj(updatedProjects);
          
          // listn()
          // Clear form fields and provide feedback
          setNewProjectName('');
          setNewThemetName(''); // Fixed typo here
          setTheme('');
          togglePopup();
          setIsProjectCreated(true);
        } catch (error) {
          // Optionally handle the error and provide feedback to the user
        }
      } else {
        alert('Only letters, numbers, and spaces allowed');
        setCreateNoProjectName(true);
      }
    } else {
      setCreateNoProjectName(newProjectName.trim() === '');
      setCreateNoThemeName(newThemeName.trim() === '');
    }
  };

  
const pushToProject = () => {
    if(projectName !== '' && selectedKeywords.length !== 0) {
      setPushNoProjectName(false)
      if(themeOperationType === 'select' && theme !== '') {
        setPushNoSelectedTheme(false)
        dispatch(addKeywords({
          pName: projectName,
          theme, theme,
          keywords: selectedKeywords
        }))

        setPushedTo(prev=> {
          return [...prev, ...ids]
        })
      // listn()
      setNewProjectName('')
      setNewThemetName('')
      setTheme('')
      togglePushPopup()
      setIsPushedToProject(true)
      } else {
        setPushNoSelectedTheme(true)
      }

      if(themeOperationType === 'new' && newThemeNameExistingProject !== '') {

        const themeNameExists = (newThemeName, currentProject) => {
          // Ensure currentProject and its themes are defined
          if (!currentProject || !currentProject.themes) {
              return false;
          }
      
          // Check if the new theme name already exists in the current project's themes
          const exists = currentProject.themes.some(theme => theme.name.trim() === newThemeName.trim());
      
          return exists;
      };



        setPushNoThemetName(false)
        let sProject = projects.find(proj=> (proj.name === projectName && proj.type === 'keyword'))

        if (themeNameExists(newThemeNameExistingProject, sProject)) {
          alert('Theme name already exists. Please choose a different name.');
          return;
        }

        let updatedProject = {
          ...sProject,
          themes: [...sProject.themes, {name: newThemeNameExistingProject, keywords: selectedKeywords}]
        }
    
        dispatch(addThemes({pName: sProject.name, updatedProject: updatedProject}))

        setPushed(true)
        // listn()
        setNewProjectName('')
        setNewThemetName('')
        setTheme('')
        togglePushPopup()
        setIsPushedToProject(true)
      } else {
        setPushNoThemetName(true)
      }
    } else {
      setPushNoProjectName(true)
    }
  }



  const cleanArr = (arr) => {
    let cleanedArr = arr.map(word => word.trim()).filter(Boolean)
    return cleanedArr
  }


  const filtered = () => {
    if (incWords.length !== 0 || excWords.length !== 0) {
      let arr = [...data];
      let filteredData = arr;
  
      if (incWords.length !== 0) {
        const incRegex = new RegExp(incWords.map(word => `\\b${word}\\b`).join('|'), 'i');
        filteredData = filteredData.filter(k => incRegex.test(k.keyword));
        setIwAltered(true)
      }
  
      if (excWords.length !== 0) {
        const excRegex = new RegExp(excWords.map(word => `\\b${word}\\b`).join('|'), 'i');
        filteredData = filteredData.filter(k => !excRegex.test(k.keyword));
        setEwAltered(true)
      }
      
  
      setData(filteredData);
    } else {
      setData(originalData)
      clearFilter()
    }
  };


  function filterKeywordsByIntent() {
    if(selectedIntent !== 'all') {
      let tempArr = [...data]
      let filteredArray = tempArr.filter(keyword => keyword.intent === selectedIntent);

      setData(filteredArray)
      setShowIntentFilter(false)
    } else {
      setData(originalData)
      setShowIntentFilter(false)
    }
  }

  const incRef = useRef(null)
  const excRef = useRef(null)

  const clearIncRef = () => {
    incRef.current.value = ''
    clearFilter()
  }

  const clearExcRef = () => {
    excRef.current.value = ''
    clearFilter()
  }


  const clearFilter = () => {
    setData(originalData)
    setIncWords([])
    setExcWords([])
    setIds([])
    setSelectedKeywords([])
    setSelectedIntent('all')
    setVMax(undefined)
    setDiffMax(undefined)
    setVMin(undefined)
    setDiffMin(undefined)
    setIntentlessData([])
    setNoData(false)
    setVMinFilterData(undefined)
    setVMaxFilterData(undefined)
    setDMinFilterData(undefined)
    setDMaxFilterData(undefined)
    setShowDifficultyFilter(false)
    setShowVolumeFilter(false)
    setShowIntentFilter(false)
    setIwAltered(false)
    setEwAltered(false)
  }
  


  useEffect(()=> {
    filterKeywordsByIntent()
  }, [selectedIntent])


  function generateBroadMatchRegex(enteredKeyword) {
    // Escape special characters in the entered keyword
    const escapedKeyword = enteredKeyword.replace(/[.*+?^${}()|[\]\\']/g, '\\$&');

    // Construct the regular expression pattern to match any order of words and variations
    const regexPattern = `.*${escapedKeyword.split(/\s+/).join('.*')}.*`;

    // Create and return the regular expression
    return new RegExp(regexPattern, 'i');
}

  function generatePhraseMatchRegex(enteredKeyword) {
    // Escape special characters in the entered keyword
    const escapedKeyword = enteredKeyword.replace(/[.*+?^${}()|[\]\\']/g, '\\$&');

    // Split the entered keyword into individual words
    const words = escapedKeyword.split(/\s+/);

    // Construct the regular expression pattern to match any order of words
    const wordPattern = words.map(word => `(?=.*\\b${word}(?:'s)?\\b)`).join('');

    // Combine the word patterns into the final regex pattern
    const regexPattern = `^${wordPattern}.+$`;

    // Create and return the regular expression
    return new RegExp(regexPattern, 'i');
}


function generateExactMatchRegex(enteredKeyword) {
  // Escape special characters in the entered keyword
  const escapedKeyword = enteredKeyword.replace(/[.*+?^${}()|[\]\\']/g, '\\$&');

  // Construct the regular expression pattern to match the exact sequence of words
  const regexPattern = `^(?=.*\\b${escapedKeyword}(?:'s)?\\b).*${escapedKeyword}(?:'s)?(?:\\b.*|$)`;

  // Create and return the regular expression
  return new RegExp(regexPattern, 'i');
}


  function filterKeywordsByMatchType(mt) {
    if(matchType === null) {
        let originalDataArr = [...originalData]

        // const regexMap = {
        //     "exact": /\[([^\]]+)\]/i,
        //     "phrase": /"([^"]+)"/i,
        //     "broad": /[^\[\]"]/i,
        // };

        // const regex = regexMap[mt];

        // const oldPhrase = new RegExp(inputKeyword.replace(/\s+/g, '\\s+'), 'i')

        let regex 

        if(mt === 'broad') regex = generateBroadMatchRegex(inputKeyword)
        if(mt === 'phrase') regex = generatePhraseMatchRegex(inputKeyword)
        if(mt === 'exact')  regex = generateExactMatchRegex(inputKeyword)
        

        

        const filteredArray = originalDataArr.filter(item => regex.test(item.keyword));
        if(filteredArray.length === 0) {
          filteredArray.push({
            nothing: 1
          })
        }
        setData(filteredArray);
        setMatchType(mt);
    } else {
        setData([...originalData]);
        setMatchType(null);
    }
}
  


const getSERP = (keyword, location) => {
  setSerpLoading(true)
  setSerpKeyword(keyword)
  fetch(`${base}/res`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      type: 'cr',
      url: 'example.com',
      keyword: keyword,
      location: location,
      userId: user.id,
      pass: true
    })
  })
  .then(res => res.json())
  .then(data => {
    const sortedData = [...data[0].data].sort((a, b) => {
      if (a.rank === 'na') return 1;
      if (b.rank === 'na') return -1;
      return a.rank - b.rank;
    });
    setSerpData([{
      data: sortedData,
      serpStructure: data[0].serpStructure
    }]);
    setSerpLayer(true)
    setSerpLoading(false)
    setKRSerpLoadingP(false)
  });
};


const serpBack = () => {
  setSerpData([])
  setSerpLayer(false)
  setSerpKeyword('')
}


useEffect(()=> {
  let timeoutId
  if(serpLoading) {
    timeoutId = setTimeout(()=> {
      setSerpData([])
      setSerpKeyword('')
      setSerpLayer(false)
      setSerpLoading(false)
      setSerpNoData(true)
      setKRSerpLoadingP(false)
    }, 25000)
  }

  return () => clearTimeout(timeoutId)
}, [serpLoading])


useEffect(()=> {
  let timeoutId
  if(serpLoading) {
    timeoutId = setTimeout(()=> {
      setKRSerpLoadingP(true)
    }, 5000)
  }

  return () => clearTimeout(timeoutId)
}, [serpLoading])


const serpNoDataBack = () => {
  setSerpNoData(false)
}


const parseVolume = (volume) => {
  return parseInt(volume.replace(/,/g, ''), 10);
};

const filterByVolume = (minVolume, maxVolume) => {
  setVMin(minVolume);
  setVMax(maxVolume);
  setVMinFilterData(minVolume);
  setVMaxFilterData(maxVolume);

  return data.filter(item => {
    const volume = parseVolume(item.volume);

    // If minVolume is provided, check if volume is >= minVolume
    const minCondition = minVolume !== undefined && minVolume !== null ? volume >= minVolume : true;

    // If maxVolume is provided, check if volume is <= maxVolume
    const maxCondition = maxVolume !== undefined && maxVolume !== null ? volume <= maxVolume : true;

    // Return items that satisfy both conditions
    return minCondition && maxCondition;
  });
};



const parseDifficulty = (difficulty) => {
  return parseInt(difficulty, 10);
};

// Function to filter data by min and max difficulty
const filterByDifficulty = (data, minDifficulty, maxDifficulty) => {

  setDMinFilterData(minDifficulty)
  setDMaxFilterData(maxDifficulty)
  
  return data.filter(item => {
      const difficulty = parseDifficulty(item.difficulty);
      
      const minDifficultyCondition = minDifficulty === undefined || minDifficulty === null || difficulty >= minDifficulty;
      const maxDifficultyCondition = maxDifficulty === undefined || maxDifficulty === null || difficulty <= maxDifficulty;
      
      return minDifficultyCondition && maxDifficultyCondition;
  })
};

const applyCustomVolumeFilter = (min, max) => {
  setSelectedIntent('all')
  const filteredData = filterByVolume(min, max);
  setData(filteredData);
  setIntentlessData(filteredData)
  setShowVolumeFilter(false)
};


const applyFilter = () => {
  setSelectedIntent('all')
  const filteredData = filterByVolume(vMin, vMax);
  setData(filteredData);
  setIntentlessData(filteredData)
  setShowVolumeFilter(false)
};


const applyCustomDifficultyFilter = (min, max) => {
  setSelectedIntent('all')
  const filteredData = filterByDifficulty(data, min, max);
  setData(filteredData);
  setIntentlessData(filteredData)
  setShowDifficultyFilter(false)
};

const applyDifficultyFilter = () => {
  setSelectedIntent('all')
  const filteredData = filterByDifficulty(data, diffMin, diffMax);
  setData(filteredData);
  setIntentlessData(filteredData)
  setShowDifficultyFilter(false)
};


const clearVolumeFilter = () => {
  setSelectedIntent('all')
  setVMax(undefined)
  setVMin(undefined)
  setVMinFilterData(undefined)
  setVMaxFilterData(undefined)
  setData(originalData)
  setShowVolumeFilter(false)
}


const clearDifficultyFilter = () => {
  setSelectedIntent('all')
  setDiffMax(undefined)
  setDiffMin(undefined)
  setData(originalData)
  setShowDifficultyFilter(false)
}


const infoBoxRef = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRef.current && !infoBoxRef.current.contains(event.target)) {
            setShowVolumeFilter(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


const infoBoxRefDiff = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRefDiff.current && !infoBoxRefDiff.current.contains(event.target)) {
            setShowDifficultyFilter(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


const infoBoxRefAddToProject = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRefAddToProject.current && !infoBoxRefAddToProject.current.contains(event.target)) {
            setAddToProjectSelection(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);



const infoBoxRefIntent = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRefIntent.current && !infoBoxRefIntent.current.contains(event.target)) {
            setShowIntentFilter(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


const infoBoxRefKeywordDiffScore = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRefKeywordDiffScore.current && !infoBoxRefKeywordDiffScore.current.contains(event.target)) {
            setShowKeywordDifficultyScoreInfo(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


const infoBoxRefMarketPotential = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRefMarketPotential.current && !infoBoxRefMarketPotential.current.contains(event.target)) {
            setShowMarketPotentialInfo(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);


const infoBoxRefInterestLevel = useRef(null);

useEffect(() => {
    // Function to handle clicks outside the InfoBox
    const handleClickOutside = (event) => {
        if (infoBoxRefMarketPotential.current && !infoBoxRefMarketPotential.current.contains(event.target)) {
            setShowInterestLevelInfo(false); // Close the popup
        }
    };

    // Add event listener for clicks outside
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
        document.removeEventListener('mousedown', handleClickOutside);
    };
}, []);






return (
    <>
    {(width > 768) && <>
    <KeywordResearchContainer>
      <KeywordResearchInputContainer>
        {!serpLayer && <>
        <h2>Keyword Research {updatesDate && <span><span>Data Last Updated</span>{updatesDate}</span>}</h2>
        <div style={{display: 'flex'}}>
          <input type='text' required placeholder='keyword' value={inputKeyword} onChange={e=> setInputKeyword(e.target.value)} style={noInput? {borderColor: 'red'}: {}}/>
          <select name="country" value={location} onChange={e=> setLocation(e.target.value)} className='select-country' style={noSelection? {borderColor: 'red'}: {}}>
              {countries()}
          </select>
          {nx !== 0 && !serpLoading && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
          {nx === 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed'}}>Insufficient Nexilum units!</button>}
          
          {/* {data.length !== 0 && !noData && !serpLoading && false && <div style={{width: '220px', height: '100px', marginLeft: '25px', marginBottom: '10px', marginRight: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <label style={{fontFamily: 'Quicksand', color: '#0d76e0', fontSize: 'small', marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '5px'}}>Keyword Difficulty <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowKeywordDifficultyScoreInfo(true)} onMouseLeave={()=> setShowKeywordDifficultyScoreInfo(false)}/></label>
          {showKeywordDifficultyScoreInfo && <InfoBox style={{top: '20%'}} ref={infoBoxRefKeywordDiffScore}>
            <p>Measures how hard it is to rank for a keyword in search engines based on competition and other factors</p>
          </InfoBox>}
            <KeywordDifficultyChart difficulty={parseInt(originalData[0]?.difficulty, 10)} /> 
          </div>}

          {data.length !== 0 && !noData && !serpLoading && false && <div style={{width: '220px', height: '100px', marginLeft: '25px', marginBottom: '10px', marginRight: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <label style={{fontFamily: 'Quicksand', color: '#0d76e0', fontSize: 'small', marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '5px'}}>Niche Market Potential <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowMarketPotentialInfo(true)} onMouseLeave={()=> setShowMarketPotentialInfo(false)}/> </label> 
          {showMarketPotentialInfo && <InfoBox style={{top: '20%'}} ref={infoBoxRefMarketPotential}>
            <p>Evaluates the overall opportunity for a keyword or market niche by considering search volume, cost-per-click, and difficulty. The higher the score, the greater the potential for attracting traffic and generating revenue, with lower competition and higher search interest</p>
          </InfoBox>}
            <NicheMarketPotentialScore data={originalData} /> 
          </div>} */}

          {/* {data.length !== 0 && !noData && !serpLoading && interestData.default.timelineData && <div style={{position: 'absolute', right: '25px', top: '38px', width: '560px', height: '110px', marginLeft: '25px', marginBottom: '10px', marginRight: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <label style={{fontFamily: 'Quicksand', color: '#0d76e0', fontSize: 'small', marginBottom: '5px', display: 'flex', alignItems: 'center', gap: '5px'}}>Interest Over Time: Keyword Popularity <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowMarketPotentialInfo(true)} onMouseLeave={()=> setShowMarketPotentialInfo(false)}/> </label> 
          {showMarketPotentialInfo && <InfoBox style={{top: '20%', zIndex: '1000000'}} ref={infoBoxRefMarketPotential}>
            <p>This chart displays the interest level of <span style={{fontFamily: 'Quicksand', color: 'dodgerblue'}}>{prevKeyword}</span> over time, based on Google data. Each point on the chart represents the keyword's popularity for a given week. Higher values indicate greater search interest during that period. Use this chart to understand seasonal trends, measure the effectiveness of marketing campaigns, or identify patterns in user behavior related to your keyword</p>
          </InfoBox>}
            <InterestChart data={interestData} /> 
          </div>} */}


          {/* {data.length !== 0 && !noData && !serpLoading && <div style={{width: '280px', height: '100px', marginLeft: 'auto', marginBottom: '10px'}}>
          <label style={{fontFamily: 'Quicksand', color: '#0d76e0', fontSize: 'small'}}>Keyword Interest Overview</label> 
            <NicheMarketPotentialScore data={originalData}/> 
          </div>} */}
            {/* {ids.length !== 0 && <ProjectsOperations style={{}}> */}

            
            {/* {!isPush && !isProject && <button className='project-btn' onClick={togglePushPopup} style={{backgroundColor: pushToProjectActive? '#1267bc': '', visibility: createProjectActive? 'hidden': 'visible'}}>Push to project</button>}
            

            {!isProject && !isPush && <button className='project-btn' onClick={togglePopup} style={{backgroundColor: createProjectActive?'#1267bc': '', visibility: pushToProjectActive? 'hidden': 'visible'}}>Create project</button>} */}

            {/* Create the popup here */}

            {showPopup && (
        <PopupOverlay>
          <PopupContent>
            <PopupHeader>
              {<h3>Create Project</h3>}
              {<CloseButton onClick={togglePopup}>Close</CloseButton>}
            </PopupHeader>
            <img src={createKP} width={200} />
            <p style={{marginBlock: '12px', color: 'dodgerblue'}}>{selectedKeywords.length} selected keywords</p>            
            <PopupBody>
              {<>
              <label>Project name: </label>
              <input type='text' required value={newProjectName} onChange={e=> setNewProjectName(e.target.value)} style={createNoProjectName? {borderColor: 'red'}: {}}/>
              <p style={{fontSize: 'small'}}>Only letters, numbers and spaces allowed</p>
              <div style={{marginBlock: '20px'}}/>
              <label>Your first theme for your new project: </label>
              <input type='text' required value={newThemeName} onChange={e=> setNewThemetName(e.target.value)} style={createNoThemeName? {borderColor: 'red'}: {}}/>
              <div style={{marginBlock: '15px'}} />
              <button onClick={createProject}>Create Project and Push Selected Keywords</button>
              </>}
            </PopupBody>
          </PopupContent>
        </PopupOverlay>
      )}
            {showPushPopup && (
        <PopupOverlay>
          <PopupContent>
            {<PopupHeader>
              <h3>Push to existing project</h3>
              <CloseButton onClick={togglePushPopup}>Close</CloseButton>
            </PopupHeader>}
            <img src={pushKP} width={280} />
            <p style={{marginBlock: '12px', color: 'dodgerblue'}}>{selectedKeywords.length} selected keywords</p>
            <PopupBody>
              {<>
              <label>Select project: </label>
              <select name="select-project" value={projectName} onChange={e=> setProjectName(e.target.value)} className='select-project' style={pushNoPRojectName? {borderColor: 'red'}: {}}>
              <option value="">Select Project</option>
              {projects?.map(p=> {
                if(p.type === 'keyword') {
                  return (
                    <option value={p.name}>{p.name}</option>
                  )
                }
              })}
            </select>
              <div style={{marginBlock: '20px'}}/>
              <>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}} className='theme-operation-type'>
                  <h5 onClick={()=> setThemeOperationType('select')} style={themeOperationType === 'select'? {color: 'dodgerblue', backgroundColor: '#e1e1e1', borderRadius: '3px', padding: '3px 5px'}: {color: 'white', backgroundColor: 'dodgerblue', borderRadius: '3px', padding: '3px 5px'}}>Select from themes</h5>
                  <h5 onClick={()=> setThemeOperationType('new')} style={themeOperationType === 'new'? {color: 'dodgerblue', backgroundColor: '#e1e1e1', borderRadius: '3px', padding: '3px 5px'}: {color: 'white', backgroundColor: 'dodgerblue', borderRadius: '3px', padding: '3px 5px'}}>Create new theme</h5>
                </div>
              </>
              {themeOperationType === 'new' && <>
                <label style={{marginTop: '15px'}}>Theme name: </label>
                <input type='text' required value={newThemeNameExistingProject} onChange={e=> setNewThemetNameExistingProject(e.target.value)} style={pushNoThemeName? {borderColor: 'red'}: {}}/>
                <div style={{marginBlock: '15px'}} />
              </>}
              {themeOperationType === 'select' && <>
              <label style={{marginTop: '15px'}}>Select theme: </label>
              <select name="select-theme" value={theme} onChange={e=> setTheme(e.target.value)} className='select-theme' style={pushNoSelectedTheme? {borderColor: 'red'}: {}}>
              <option value="">Select Theme</option>
              {projects?.map(p=> {
                if(p.name === projectName && p.type === 'keyword') {
                  return p.themes.map(t=> {
                    return (
                      <option value={t.name}>{t.name}</option>
                    )
                  })
                }
              })}
            </select>
              <div style={{marginBlock: '15px'}} />
              </>}
              {themeOperationType !== '' && <button onClick={pushToProject}>Push</button>}
              </>}
            </PopupBody>
          </PopupContent>
        </PopupOverlay>
      )}

            {/* Create the popup here */}
            {/* </ProjectsOperations>} */}
        </div>

        {data.length !== 0 && !noData && !(data.length === 1 && data[0].keyword == 'N/A') && !serpLayer && !serpLoading && !serpNoData && <KeywordsTools>
        <div style={{position: 'relative', marginBottom: '0px'}}><label style={{position: 'absolute', transform: 'translateY(-90%)', left: '23px', top: '20%', fontSize: 'small'}}>include words</label><input type='text' placeholder='near me, best, ...' style={{marginLeft: '20px'}} ref={incRef} onChange={e=> setIncWords(cleanArr(e.target.value.split(',')))}/></div>
        {incWords.length !== 0 && <button onClick={filtered}>Apply</button>}
        {incWords.length === 0 && <button style={{backgroundColor: 'lightgray', color: 'gray'}}>Apply</button>}
        {iwAltered && <button onClick={clearFilter}>Clear</button>}
        <div style={{position: 'relative', marginBottom: '0px'}}><label style={{position: 'absolute', transform: 'translateY(-90%)', left: '23px', top: '20%', fontSize: 'small'}}>exclude words</label><input type='text' placeholder='free, cheap, ...' style={{marginLeft: '20px'}} ref={excRef} onChange={e=> setExcWords(cleanArr(e.target.value.split(',')))}/></div>
        {excWords.length !== 0 && <button onClick={filtered}>Apply</button>}
        {excWords.length === 0 && <button style={{backgroundColor: 'lightgray', color: 'gray'}}>Apply</button>}
        {ewAltered && <button onClick={clearFilter}>Clear</button>}
      
        <div className='match-types'>
        <div style={{backgroundColor: matchType === 'broad'? 'rgb(235, 235, 235)': 'dodgerblue', color: matchType === 'broad'? 'dodgerblue': 'white'}} onClick={()=> filterKeywordsByMatchType('broad')}>Broad Match Modifier</div>
        <div style={{backgroundColor: matchType === 'phrase'? 'rgb(235, 235, 235)': 'dodgerblue', color: matchType === 'phrase'? 'dodgerblue': 'white'}} onClick={()=> filterKeywordsByMatchType('phrase')}>Phrase Match</div>
        <div style={{backgroundColor: matchType === 'exact'? 'rgb(235, 235, 235)': 'dodgerblue', color: matchType === 'exact'? 'dodgerblue': 'white'}} onClick={()=> filterKeywordsByMatchType('exact')}>Exact Match</div>
        </div>
        </KeywordsTools>}
        </>}

        {serpData.length !== 0 && serpLayer &&
        <>
          <div className='serp-header'>
            <h2 style={{width: '100%'}}>SERP results for <span style={{color: 'dodgerblue'}}>{serpKeyword}</span> in <span style={{color: 'dodgerblue'}}>{getCountryName(location)}</span></h2>
            <p onClick={()=> serpBack()}>Back <KeyboardBackspaceIcon style={{ transform: 'rotate(180deg)', marginLeft: 'auto'}}/></p>
          </div>
          <h3 style={{color: 'slategray', display: 'flex', fontWeight: 'normal', alignItems: 'center', gap: '3px'}}><TextureIcon /> Search Results Content Type: <span style={{fontFamily: 'Quicksand', color: 'white', backgroundColor: 'Var(--se-color)', padding: '2px', borderRadius: '4px', marginInline: '5px'}}>{serpData[0].serpStructure.match(/^[^(]+/)[0].trim()}</span><span style={{fontFamily: 'Quicksand', color: 'Var(--se-color)'}}>{serpData[0].serpStructure.match(/\(([^)]+)\)/)[1].trim()}</span></h3>
          </>
        }
      </KeywordResearchInputContainer>



        {/* {data.length !== 0 && !noData && !isLoading && !data[0]?.nothing && !(data.length === 1 && data[0].keyword == 'N/A') && !serpLayer && !serpLoading && <DataContainer style={{position: 'relative'}}> */}
        {/* {<ChartContainer>

          <div style={{width: '20%', height: '365px'}}>
          <Card>
            <CardHeader>
          <h3>Keyword Difficulty <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowKeywordDifficultyScoreInfo(true)} onMouseLeave={()=> setShowKeywordDifficultyScoreInfo(false)}/></h3>
          {showKeywordDifficultyScoreInfo && <InfoBox style={{top: '20%', left: '19%'}} ref={infoBoxRefKeywordDiffScore}>
            <p>Measures how hard it is to rank for a keyword in search engines based on competition and other factors</p>
          </InfoBox>}
          </CardHeader>
            <KeywordDifficultyChart difficulty={parseInt(originalData[0]?.difficulty, 10)} /> 
          </Card>

          <Card style={{marginTop: 'auto'}}>
            <CardHeader>
          <h3>Niche Market Potential <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowMarketPotentialInfo(true)} onMouseLeave={()=> setShowMarketPotentialInfo(false)}/> </h3> 
          {showMarketPotentialInfo && <InfoBox style={{top: '40%', left: '25%'}} ref={infoBoxRefMarketPotential}>
            <p>Evaluates the overall opportunity for a keyword or market niche by considering search volume, cost-per-click, and difficulty. The higher the score, the greater the potential for attracting traffic and generating revenue, with lower competition and higher search interest</p>
          </InfoBox>}
          </CardHeader>
            <NicheMarketPotentialScore data={originalData} /> 
          </Card>
        </div>

        <Card style={{width: '80%', height: '350px'}}>
            <CardHeader>
            <h3>Interest Over Time: Keyword Popularity</h3>
            <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowInterestLevelInfo(true)} onMouseLeave={()=> setShowInterestLevelInfo(false)}/>
            {showInterestLevelInfo && <InfoBox style={{top: '20%', left: '50%'}} ref={infoBoxRefInterestLevel}>
              <p>This chart displays the interest level of a <span style={{fontFamily: 'Quicksand', color: 'dodgerblue'}}>{prevKeyword}</span> over time, based on Google data. Each point on the chart represents the keyword's popularity for a given week. Higher values indicate greater search interest during that period. Use this chart to understand seasonal trends, measure the effectiveness of marketing campaigns, or identify patterns in user behavior related to your keyword</p>
            </InfoBox>}
            </CardHeader>

            {interestData.default.timelineData? <InterestChart data={interestData} /> : <p style={{alignSelf: 'center', justifySelf: 'center', marginBottom: '200px'}}>No Data Available</p>}
        </Card>
        </ChartContainer>} */}

        {/* {<ChartContainer>
        <div>
          <Card>
            <CardHeader>
          <h3>Keyword Difficulty <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowKeywordDifficultyScoreInfo(true)} onMouseLeave={()=> setShowKeywordDifficultyScoreInfo(false)}/></h3>
          {showKeywordDifficultyScoreInfo && <InfoBox style={{top: '20%'}} ref={infoBoxRefKeywordDiffScore}>
            <p>Measures how hard it is to rank for a keyword in search engines based on competition and other factors</p>
          </InfoBox>}
          </CardHeader>
            <KeywordDifficultyChart difficulty={parseInt(originalData[0]?.difficulty, 10)} /> 
          </Card>

          <Card>
            <CardHeader>
          <h3>Niche Market Potential <InfoIcon style={{color: 'lightgray', cursor: 'help', fontSize: 'small', position: 'relative'}} onMouseEnter={()=> setShowMarketPotentialInfo(true)} onMouseLeave={()=> setShowMarketPotentialInfo(false)}/> </h3> 
          {showMarketPotentialInfo && <InfoBox style={{top: '20%'}} ref={infoBoxRefMarketPotential}>
            <p>Evaluates the overall opportunity for a keyword or market niche by considering search volume, cost-per-click, and difficulty. The higher the score, the greater the potential for attracting traffic and generating revenue, with lower competition and higher search interest</p>
          </InfoBox>}
          </CardHeader>
            <NicheMarketPotentialScore data={originalData} /> 
          </Card>
        </div>
          
        </ChartContainer>} */}


      {data.length !== 0 && !noData && !isLoading && !data[0]?.nothing && !(data.length === 1 && data[0].keyword == 'N/A') && !serpLayer && !serpLoading && <KeywordsContainer style={{position: 'sticky', top: '0', marginBottom: '0px', zIndex: (showPopup || showPushPopup || showMarketPotentialInfo)? '1': '100000', borderRadius: "2px 2px 0 0"}}>
      <Keyword>
      <div onClick={()=> selectAll()} style={{display: 'flex', justifyContent: 'center', alignItems: 'center',marginInline: '10px', border: '1px solid rgb(200, 200, 200)', width: '25px', height: '15px', cursor: 'pointer', backgroundColor: ids.length == data.length? 'rgb(2, 97, 193)': '', borderRadius: '3px'}} className='check_box'></div>
      
      {ids.length == 0 && <div style={{width: '390px', fontFamily: 'Quicksand', color: 'black', fontSize: 'small'}}>Keywords <span style={{fontFamily: 'Quicksand', color: 'gray', marginLeft: '10px'}}>{data.length} keywords</span></div>}
      {ids.length > 0 && <div style={{width: '390px', fontFamily: 'Quicksand', fontSize: 'small'}}><span style={{fontFamily: 'Quicksand', color: 'dodgerblue', marginRight: '5px'}}>{ids.length}</span> <span style={{fontFamily: 'Quicksand', color: 'gray'}}>{ids.length === 1? 'keyword': 'keywords'}</span> <span style={{fontFamily: 'Quicksand', color: 'dodgerblue', marginLeft: '10px', cursor: 'pointer', position: 'relative'}} onClick={()=> setAddToProjectSelection(prev=> !prev)}>Add to project</span>
      {addToProjectSelection && <InfoBox ref={infoBoxRefAddToProject} style={{top: '67%'}}>
          <div>
            <button onClick={()=> {setShowPushPopup(true); setAddToProjectSelection(false);}}>Push To Project</button>
            {!user?.prem && projects?.length < 5 && <button onClick={()=> {setShowPopup(true); setAddToProjectSelection(false);}}>Create New Project</button>}
            {user?.prem && <button onClick={()=> {setShowPopup(true); setAddToProjectSelection(false);}}>Create New Project</button>}
            {!user?.prem && projects?.length >= 5 && <button style={{backgroundColor: 'lightgray', color: 'gray'}}>Limit reached!</button>}
          </div>
      </InfoBox>}
      </div>}
      

      <div style={{width: '260px', marginLeft: '80px', fontFamily: 'Quicksand', color: 'black', fontSize: 'small', display: 'flex', alignItems: 'center', gap: '3px'}}>Avg. CPC (USD) <InfoIcon style={{fontSize: 'small', color: 'lightgray', cursor: 'help'}} onMouseEnter={()=> setCpcInfo(true)}  onMouseLeave={()=> setCpcInfo(false)}/> <span style={{fontFamily: 'Quicksand', color: 'dodgerblue', cursor: 'pointer'}} onClick={()=> sorting('cpc')}>sort</span></div>
      {cpcInfo && <InfoBox style={{top: '67%', left: '30%'}}>
      <h4>Definition</h4>
      <p>Average CPC represents the amount advertisers are willing to pay for each click on their ad when bidding for a keyword in paid search campaigns</p>
      <h4>Importance</h4>
      <p>Average CPC helps in budgeting for paid campaigns, guiding decisions on keyword selection based on cost and potential ROI</p>
      </InfoBox>}

      <div style={{width: '300px', marginLeft: '80px', fontFamily: 'Quicksand', color: 'black', fontSize: 'small', display: 'flex', alignItems: 'center', gap: '3px'}}>Volume (Monthly) <InfoIcon style={{fontSize: 'small', color: 'lightgray', cursor: 'help', zIndex: '10000'}} onMouseEnter={()=> setVolumeInfo(true)}  onMouseLeave={()=> setVolumeInfo(false)}/> <span style={{fontFamily: 'Quicksand', color: 'dodgerblue', cursor: 'pointer'}} onClick={()=> setShowVolumeFilter(prev=> !prev)}>filter</span></div>
      {(vMinFilterData || vMaxFilterData) && <div className='filterData' style={{position: 'absolute', top: '60%', left: '50%', fontSize: 'small', color: 'dodgerblue'}}>{vMinFilterData && vMinFilterData} {(vMinFilterData && vMaxFilterData) && ' - '} {vMaxFilterData && vMaxFilterData}</div>}
      {volumeInfo && <InfoBox style={{top: '67%', left: '50%'}}>
      <h4>Definition</h4>
      <p>Volume represents the average number of searches a keyword receives per month</p>
      <h4>Importance</h4>
      <p>Understanding the volume helps you identify popular keywords that can drive more traffic to your content, enabling you to target the terms with the highest potential impact</p>
      </InfoBox>}

      {showVolumeFilter && <InfoBox style={{top: '67%', left: '55%', width: '200px'}} ref={infoBoxRef}>
        <div className='pre' onClick={()=> applyCustomVolumeFilter(100001, undefined)}><h4>+100,001</h4></div>
        <div className='pre' onClick={()=> applyCustomVolumeFilter(10001, 100000)}><h4>10,001 - 100,000</h4></div>
        <div className='pre' onClick={()=> applyCustomVolumeFilter(1001, 10000)}><h4>1001 - 10,000</h4></div>
        <div className='pre' onClick={()=> applyCustomVolumeFilter(101, 1000)}><h4>101 - 1000</h4></div>
        <div className='pre' onClick={()=> applyCustomVolumeFilter(11, 100)}><h4>11 - 100</h4></div>
        <div className='pre' onClick={()=> applyCustomVolumeFilter(1, 10)}><h4>1 - 10</h4></div>
          

          <div className='custom'>
            <h4>Custom Range</h4>
            <div>
              <input type='number' placeholder='from' value={vMin} onChange={e=> setVMin(e.target.value)}/>
              <input type='number' placeholder='to' value={vMax} onChange={e=> setVMax(e.target.value)}/>
            </div>
          </div>
          <div style={{marginTop: '10px'}}>
              <button onClick={()=> applyFilter(vMin, vMax)}>Apply</button>
              <button onClick={clearFilter}>Clear Filter</button>
          </div>
        
      </InfoBox>}

      <div style={{width: '100px', marginLeft: '80px', fontFamily: 'Quicksand', color: 'black', fontSize: 'small', display: 'flex', alignItems: 'center', gap: '3px'}}>Difficulty <InfoIcon style={{fontSize: 'small', color: 'lightgray', cursor: 'help'}} onMouseEnter={()=> setDifficultyInfo(true)} onMouseLeave={()=> setDifficultyInfo(false)}/> <span style={{fontFamily: 'Quicksand', color: 'dodgerblue', cursor: 'pointer'}} onClick={()=> setShowDifficultyFilter(prev=> !prev)}>filter</span></div>
      {(dMinFilterData || dMaxFilterData) && <div className='filterData' style={{position: 'absolute', top: '60%', left: '70%', fontSize: 'small', color: 'dodgerblue'}}>{dMinFilterData && `${dMinFilterData}%`} {(dMinFilterData && dMaxFilterData) && ' - '} {dMaxFilterData && `${dMaxFilterData}%`} {(dMinFilterData && dMaxFilterData) && 
        dMinFilterData >= 0 && dMaxFilterData <=14? 'Very Easy':
        dMinFilterData >= 15 && dMaxFilterData <= 29? 'Easy':
        dMinFilterData >= 30 && dMaxFilterData <= 49? 'Possible':
        dMinFilterData >= 50 && dMaxFilterData <= 69? 'Difficult':
        dMinFilterData >= 70 && dMaxFilterData <= 84? 'Hard':
        dMinFilterData >= 85 && dMaxFilterData <= 100? 'Very Hard': ''
        }</div>}
      {difficultyInfo && <InfoBox style={{top: '67%', left: '65%'}}>
      <h4>Definition</h4>
      <p>A metric that indicates how challenging it is to rank for a specific keyword in search engine results</p>
      <h4>Importance</h4>
      <p>Helps in assessing the competition level and selecting keywords that balance search volume with ranking potential</p>
      </InfoBox>}

      {showDifficultyFilter && <InfoBox style={{top: '67%', left: '65%', width: '200px'}} ref={infoBoxRefDiff}>
        <div className='pre' onClick={()=> applyCustomDifficultyFilter(85, 100)}>
          <h4>Very Hard</h4>
          <p>85% - 100%</p>
        </div>
        <div className='pre' onClick={()=> applyCustomDifficultyFilter(70, 84)}>
          <h4>Hard</h4>
          <p>70% - 84%</p>
        </div>
        <div className='pre' onClick={()=> applyCustomDifficultyFilter(50, 69)}>
          <h4>Difficult</h4>
          <p>50% - 69%</p>
        </div>
        <div className='pre' onClick={()=> applyCustomDifficultyFilter(30, 49)}>
          <h4>Possible</h4>
          <p>30% - 49%</p>
        </div>
        <div className='pre' onClick={()=> applyCustomDifficultyFilter(15, 29)}>
          <h4>Easy</h4>
          <p>15% - 29%</p>
        </div>
        <div className='pre' onClick={()=> applyCustomDifficultyFilter(0, 14)}>
          <h4>Very Easy</h4>
          <p>0% - 14%</p>
        </div>
          

          <div className='custom'>
            <h4>Custom Range</h4>
            <div>
              <input type='number' placeholder='from' value={diffMin} onChange={e=> setDiffMin(e.target.value)}/>
              <input type='number' placeholder='to' value={diffMax} onChange={e=> setDiffMax(e.target.value)}/>
            </div>
          </div>
          <div style={{marginTop: '10px'}}>
              <button onClick={()=> applyDifficultyFilter()}>Apply</button>
              <button onClick={clearFilter}>Clear Filter</button>
          </div>
        
      </InfoBox>}
      
      <div style={{width: '200px', marginLeft: '80px', fontFamily: 'Quicksand', color: 'black', fontSize: 'small', display: 'flex', alignItems: 'center', gap: '3px', marginRight: '17px'}}>Intent <InfoIcon style={{fontSize: 'small', color: 'lightgray', cursor: 'help'}} onMouseEnter={()=> setIntentInfo(true)} onMouseLeave={()=> setIntentInfo(false)}/> <span style={{fontFamily: 'Quicksand', color: 'dodgerblue', cursor: 'pointer', color: selectedIntent === 'Commercial'? 'var(--tst-color)': selectedIntent === 'Informational'? 'blue': selectedIntent === 'Mixed'? 'palevioletred': 'dodgerblue'}} onClick={()=> setShowIntentFilter(prev=> !prev)}>filter</span></div>
      {intentInfo && <InfoBox style={{top: '67%', left: '75%'}}>
      <h4>Definition</h4>
      <p>The purpose behind a user's search query, indicating whether they're looking to make a purchase, find information, or perform a specific action</p>
      <h4>Importance</h4>
      <p>Understanding keyword intent helps tailor content to match user needs, improving relevance, engagement, and conversion rates</p>
      </InfoBox>}

      {showIntentFilter && <InfoBox style={{top: '67%', left: '80%', width: '200px'}} ref={infoBoxRefIntent}>
        <div className='pre' onClick={()=> setSelectedIntent('all')}><h4>All</h4></div>
        <div className='pre' onClick={()=> setSelectedIntent('Commercial')}><h4 style={{color: 'var(--tst-color)'}}>Commercial intent</h4></div>
        <div className='pre' onClick={()=> setSelectedIntent('Informational')}><h4 style={{color: 'blue'}}>Informational intent</h4></div>
        <div className='pre' onClick={()=> setSelectedIntent('Mixed')}><h4 style={{color: 'palevioletred'}}>Mixed Intent</h4></div>
      </InfoBox>}
      </Keyword>
      </KeywordsContainer>}

      {data.length !== 0 && !noData && !isLoading && !data[0]?.nothing && !(data.length === 1 && data[0].keyword == 'N/A') && !serpLayer && !serpLoading && <KeywordsContainer style={{zIndex: (showPopup || showPushPopup || showMarketPotentialInfo)? '1': '1000', marginTop: '0px', borderRadius: "0 0 2px 2px", height: '305px'}}>
        
        {<div style={{overflowX: 'hidden', overflowY: 'scroll'}}><div>{data?.slice(0, vList).map((k, _i) => {
            // Ensure k is an object and k.keyword is a string before calling toLowerCase()
            if (typeof k !== 'object' || k === null || typeof k.keyword !== 'string') return;

            // Convert k.keyword to lowercase and check its value
            const keyword = k.keyword?.toLowerCase();
            if (keyword === 'n/a' || keyword === 'na') return;

            // Proceed with rendering or other operations
            return (
            <>
            <Keyword key={k.keyword} style={{backgroundColor: ids.includes(k.keyword)? 'rgb(223, 239, 255)': '', color: 'dodgerblue', zIndex: '100'}}>
              <div onClick={()=> uSelection(_i, k.keyword, k.volume, k.cpc, k.intent, k.difficulty)} style={{display: 'flex', justifyContent: 'center', alignItems: 'center',marginInline: '10px', border: '1px solid rgb(200, 200, 200)', width: '20px', height: '15px', cursor: 'pointer', backgroundColor: ids.includes(k.keyword)? 'rgb(2, 97, 193)': '', borderRadius: '3px'}} className='check_box'></div>
              <div style={{width: '390px', fontFamily: 'Quicksand', fontWeight: '500', color: '#065eb7'}}><p style={{fontFamily: 'Quicksand', fontWeight: '500', color: '#065eb7'}}>{k.keyword} {nx !== 0 && <span className='serp-btn' onClick={()=> getSERP(k.keyword, location)}>SERP</span>}</p></div>
              <div style={{width: '200px', marginLeft: '50px', fontFamily: 'Quicksand', color: 'black'}}>{(k.cpc !== '$0.00' && k.cpc !== null) && k.cpc.replace('$', '')} {(k.cpc === '$0.00' || k.cpc === null) && <span style={{color: 'gray', fontSize: 'small', marginLeft: '0px'}}>Insufficient Data</span>}</div>
              <div style={{width: '300px', marginLeft: '60px', fontFamily: 'Quicksand', color: 'black'}}>{k.volume? k.volume : 'No Data'}</div>
              <div style={{width: '100px', marginLeft: '30px', fontFamily: 'Quicksand', fontSize: '16px', padding: '2px 0 2px 2px'}}><span style={{backgroundColor: k.difficulty !== 'NaN'? getColorForDifficulty(k.difficulty): '#e4e4e4', color: 'black', padding: '3px', borderRadius: '5px', height: 'fit-content'}}>{k.difficulty !== 'NaN'? `${k.difficulty}%`: 'No Data'}</span></div>
              <div style={{width: '200px', marginLeft: '80px', color: k.intent === 'Commercial'? 'rgb(46, 222, 152)': k.intent=== 'Informational'? 'blue': k.intent === 'Mixed'? 'palevioletred': 'gray', fontFamily: 'Quicksand'}}>{k.intent}</div>
            </Keyword>
            </>
          )
        })}</div>

        
        {<LoadMore>{(vList < data?.length) && <h4 onClick={nxtP}>Load More</h4>}</LoadMore>}

        </div>}
      </KeywordsContainer>}
      {/* </DataContainer>} */}
      {data[0]?.nothing && <KeywordsContainer>
              <p className='notFound'>No keywords found for the selected match type</p>
      </KeywordsContainer>}
      {isLoading && <Loading />}
      {isLoading && <LoadingBar dur='35' />}
      {noData &&  (data.length === 0 || data[0].error) && !isLoading && <KeywordsContainer style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '15px 5px', gap: '6px'}}>
        <SentimentDissatisfiedIcon /> <p>We apologize, but no data {originalData.length === 0? 'is available at the moment. Please try again later.': 'for this filter!'}</p> {originalData.length !== 0 && <button onClick={clearFilter} style={{padding: '3px 6px', border: 'none', borderRadius: '2px', backgroundColor: 'dodgerblue', cursor: 'pointer', color: 'white'}}>Clear filter</button>}
      </KeywordsContainer>}

      {data.length === 1 && data[0].keyword === 'N/A' && !isLoading && <KeywordsContainer style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '15px 5px', gap: '6px'}}>
        <SentimentDissatisfiedIcon /> <p>There are not many searches for '<span style={{color: 'skyblue'}}>{prevKeyword}</span>' in the selected location!</p> 
      </KeywordsContainer>}

      {serpNoData && serpData.length === 0 && <KeywordsContainer style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '15px 5px', gap: '6px'}}>
      <SentimentDissatisfiedIcon /> <p>We couldn't retrieve the search results data at this time. Please try again later</p> {originalData.length !== 0 && <button onClick={()=> serpNoDataBack()} style={{padding: '3px 6px', border: 'none', borderRadius: '2px', backgroundColor: 'dodgerblue', cursor: 'pointer', color: 'white'}}>Back</button>} 
      </KeywordsContainer>}

      {isProjectCreated && <SuccessfulOperation><CheckCircleIcon /> Project created successfully</SuccessfulOperation>}
      {isPushedToProject && <SuccessfulOperation><CheckCircleIcon /> Pushed to project successfully</SuccessfulOperation>}


        

      {serpLayer && serpData.length !== 0 && <CompetitionResContainer>
            <CompetitorContainer>
                        {/* <p style={{width: '30x', marginRight: '50px'}}>Select</p> */}
                        <p style={{width: '20px', fontSize: 'small'}}>Rank</p>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '25px'}}><div style={{display: 'flex', flexDirection: 'row'}}><span style={{marginLeft: '7px', fontSize: 'small'}}>Website</span></div></div>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'small'}}>Page Authority</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'small'}}>Domain Authority</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'small'}}>Est. Traffic</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'small'}}>Dofollow Links</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'small'}}>Domains</p>
            </CompetitorContainer>
            <div style={{overflowX: 'hidden', overflowY: 'scroll'}}>
            {serpData[0]?.data.map((c, i)=> {
                if(c.rank === 'na') {return}
                return (
                    <>
                    {false && <div style={{display: 'flex', flexDirection: 'row', padding: '10px', margin: '5px 20px', color: 'orange', alignItems: 'center'}}><ReportProblemIcon style={{marginRight: '10px'}} /> We couldn't get the first {Number(data[i].rank) - 1} websites!</div>}
                    <CompetitorContainer selected={false}>
                      {/* <div style={{width: '20px', height: '20px', margin: '0 80px 0px 0'}}><SelectBox selected={selectedCompetitors.includes(c.url)} onClick={() => handleCompetitorSelect(c.url)}/></div> */}
                        <p style={{width: '20px', fontSize: 'medium'}}>{c.rank}</p>
                        <div><div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><img src={c.img}/><span style={{fontWeight: 'normal', marginLeft: '7px', color: 'dodgerblue', cursor: 'pointer'}} onClick={()=> window.open(c.url, '_blank')}>{c.title}</span></div><span style={{color: '#019701', fontSize: 'small', wordBreak: 'break-all'}}>{c.url}</span></div>
                        {/* <p style={{marginLeft: '27px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{generateCircleDotCR(10, c.pa)}{c.pa}</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{generateCircleDotCR(10, c.da)}{c.da}</p> */}
                        <p style={{marginLeft: '27px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{c.pa}</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{c.da}</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'medium'}}>{c.et}</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'medium'}}>{c.dofollow}</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium'}}>{c.domains}</p>
                    </CompetitorContainer>
                    </>
                )
            })}
            </div>
        </CompetitionResContainer>}

        {serpLoading && <div style={{width: '95%', height: '400px', display: 'flex', flexDirection: 'column', gap: '10px', justifyContent: 'center', alignItems: 'center', zIndex: '100000'}}>
          <KRSerpLoading /> 
          {!kRSerpLoadingP && <p style={{fontFamily: 'Quicksand', color: 'orange'}}>Getting the latest search engine results page for <span style={{fontWeight: 'bold'}}>{serpKeyword}</span> in <span style={{fontWeight: 'bold'}}>{getCountryName(location)}</span> ...</p>}
          {kRSerpLoadingP && <p style={{fontFamily: 'Quicksand', color: 'orange'}}>We are now analyzing the SERP to determine the content type</p>}
          </div>}


        {data.length === 0 && !isLoading && !serpLoading && !noData && <Intro>

          <h3>Tool Overview</h3>
          <br></br>
          <p>
            The Keyword Research Tool helps you discover the most relevant keywords for your content, 
            allowing you to optimize your SEO strategy and reach a wider audience
          </p>
          <br></br><br></br>
          <h3>Instructions</h3><br></br>
          <p>1. Enter a keyword or phrase in the search bar</p><br></br>
          <p>2. Select your target location</p><br></br>
          <p>3. Click "Get Data" to generate keywords</p><br></br>
          <br></br><br></br>
          <h3>Tips</h3><br></br>
          <p>Focus on keywords with high search volume and low competition for better results</p>  
          
        </Intro>}
    </KeywordResearchContainer>
    </>}



    {(width < 768) && <>
    
      {/* media q */}
    
    </>}

    </>
  );
}

export default KeywordResearch;



const KeywordResearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
`

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`

const KeywordResearchInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h2 {
    font-weight: 100;
    margin-bottom: 20px;
    width: 100% !important;
    display: flex;

    > span {
      margin-left: auto !important;
      font-family: 'Quicksand';
      font-size: large;
      color: dodgerblue;
      font-weight: 500;

      > span {
        font-family: 'Quicksand';
        font-size: medium;
        color: gray;
        font-weight: 300;
        margin-right: 10px;
      }
    }
  }


  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: #065eb7;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: #065eb7;
  }


  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: dodgerblue;
    color: white;
  }

  > div > button:hover {
    color: dodgerblue;
    background-color: rgb(239, 239, 239);
  }


  > .serp-header {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;

    > h2 {
      font-weight: 100;
      margin-bottom: 20px;
    }

    > p {
      margin-left: auto;
      display: flex;
      flex-direction: row;
      align-items: center;
      font-family: 'Quicksand';
      font-size: 15px;
      transition: color 0.3s ease-in-out;
      cursor: pointer;

      &:hover {
        color: dodgerblue;
      }
    }
  }
`


const changeColor = keyframes`
  0% {
    color: dodgerblue;
  }

  50% {
    color: white;
  }

  100% {
    color: dodgerblue;
  }
`


const changeColorBtn = keyframes`
  0% {
    background-color: dodgerblue;
    color: white;
  }

  50% {
    background-color: white;
    color: dodgerblue;
  }

  100% {
    background-color: dodgerblue;
    color: white;
  }
`


const ProjectsOperations = styled.div`
  display: flex;
  flex-direction: row;
  margin-left: auto;
  width: 500px;
  z-index: 1000;

  opacity: 0;
  animation: ${fadeInAnimation} 1s ease-in-out forwards;

  > .select-project {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 25px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 10px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: dodgerblue;

    animation: ${changeColor} 2s ease-in-out infinite;
  }


  > .select-theme {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 25px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 10px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: dodgerblue;

    animation: ${changeColor} 2s ease-in-out infinite;
  }


  > .project-btn {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 10px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: dodgerblue;
    color: white;
    width: 190px;
    transition: box-shadow 0.5s ease-in-out;

    /* animation: ${changeColorBtn} 10s ease-in-out infinite; */

    &:hover {
      box-shadow: 1px 10px 16px -3px #b8b8b8;
    }
  }


  > .project-btn:hover {
    /* filter: grayscale(0.6); */
  }


  > .pushedToProject {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    margin-left: auto;

    opacity: 0;
    animation: ${fadeInAnimation} 1s ease-in-out forwards;
  }

  > .pushedToProject > span {
    animation: ${changeColor} 2s ease-in-out infinite;
    font-size: larger;
    z-index: 12;
  }

  > .pushedToProject > img {
    width: 120px;
    position: absolute;
    z-index: 10;
  }
`

const KeywordsTools = styled.div`
  display: flex;
  margin-top: 20px;
  justify-content: center;
  align-items: center;
  z-index: 2;

  opacity: 0;
  animation: ${fadeInAnimation} 1s ease-in-out forwards;

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 160px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    /* margin-block: 10px; */
    color: #065eb7;
    padding-left: 100px;
    font-size: medium;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }

  > button {
    margin: 0px !important;
    margin-left: 10px !important;
  }

  > .match-types {
    display: flex;
    flex-direction: row;
    padding: 2px;
    height: 35px;
    justify-content: center;
    align-items: center;
    margin-left: 50px;
    gap: 10px;
  }

  > .match-types > div {
    border-radius: 4px;
    padding: 3px 5px;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    width: fit-content;
  }


  > .match-types > div:hover {
    background-color: rgba(235, 235, 235);
    color: #065eb7;
  }
`


const KeywordsContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  /* overflow-x: hidden;
  overflow-y: hidden; */
  background-color: white;
  border-radius: 2px;
  z-index: 100;
  margin-bottom: 70px;
  font-family: 'Roboto Flex';

  opacity: 0;
  animation: ${fadeInAnimation} 0.7s ease-in-out forwards;

  > div {
    font-family: 'Roboto Flex';
  }
`

const Keyword = styled.div`
  display: flex;
  flex-direction: row;
  margin: 20px;
  padding: 15px;
  border-radius: 2px;
  background-color: white;
  margin: 5px 5px;
  border-bottom: 1px solid rgb(230, 230, 230);
  font-family: 'Roboto Flex';
  z-index: 1000;

  &:hover {
    background-color: #d3d3d341;
  }

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;


  > .check_box {
    &:hover {
      background-color: #ebebeb;
    }
  }

  > div {
    display: flex;
    font-family: 'Roboto Flex';

    > .filterData {
      
      font-size: medium;
    }


    > p > .serp-btn {
      color: var(--se-color);
      background-color: #f2f2f2;
      cursor: pointer;
      font-family: 'Quicksand';
      margin-left: 7px;
      transition: background-color 0.3s ease-in-out !important;
      padding: 2px;
      border: none;
      border-radius: 5px;
      font-size: small;
      height: fit-content !important;

      &:hover {
        background-color: transparent !important;
        color: var(--se-color);
      }
    }
  }

  > div > .pushed {
  animation: ${changeColor} 2s ease-in-out infinite;
  margin-left: auto;
  width: fit-content;
  margin-right: 35px;
  opacity: 0.6;
  }

  > .intent-box {
    > div {
      &:hover {
        opacity: 0.7;
      }
    }
  }
`


const PopupOverlay = styled.div`
  position: absolute;
  /* top: 30%;
  left: 40%; */
  width: 100%;
  height: 100%;
  /* width: 100vw;
  height: 100vh; */
  /* background-color: rgba(0, 0, 0, 0.5); */
  top: 0;
  left: 10px;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100000;

  opacity: 0;
  animation: ${fadeInAnimation} 0.7s ease-in-out forwards;
`;

const PopupContent = styled.div`
  background-color: ${props=> props.pushed? 'transparent': 'white'};
  border-radius: 8px;
  padding: 20px;
  box-shadow: ${props=> props.pushed? '': '0 0 10px rgba(0, 0, 0, 0.2)'};
  z-index: 10000;
  width: 400px;
  height: 480px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
`;

const PopupHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 26px;
  z-index: 10000;
  width: 100%;


  > h3 {
    font-size: large;
    font-weight: 500;
    color: #065eb7;
    margin-right: 20px;
    font-family: 'Quicksand'
  }
`;

const CloseButton = styled.button`
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 14px;
  

  &:hover {
    color: red;
  }
`;

const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  z-index: 10000;
  margin-top: auto;
  margin-bottom: 35px;

  
  height: 200px;
  width: 300px;

  > input {
    border: 1px solid lightgray;
    outline: none;
    height: fit-content;
    padding: 5px 3px;
    color: #065eb7;
  }


  > button {
    border: 1px solid #065eb7;
    background-color: #065eb7;
    color: white;
    border-radius: 3px;
    cursor: pointer;
    padding: 5px;
  }

  > button:hover {
    background-color: transparent;
    color: dodgerblue;
    border: 1px solid lightgray;
  }

  > select {
    padding: 5px;
    outline: none;
    border: 1px solid lightgray;
  }

  > .pushedToProjectAnimation {
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  > .pushedToProjectAnimation > p {
    position: fixed;
    padding-block: 15px;
    width: 100vw;
    color: white;
    background-color: rgb(46, 222, 152);
  }


  > .theme-operation-type > h5 {
    cursor: pointer;
    color: dodgerblue;
    font-weight: 400;
  }

  > .theme-operation-type > h5:hover {
    color: gray;
  }
`;


const LoadMore = styled.div`
  display: flex;
  margin-top: 10px;

  > h4 {
    cursor: pointer;
    border: 1px solid lightgray;
    padding: 3px 6px;

    &:hover {
      color: dodgerblue;
      box-shadow: 0 7px 10px rgba(0, 0, 0, 0.2);
    }
  }
`


const SuccessfulOperation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-left: 490px;
  gap: 15px;
  background-color: rgb(46, 222, 152);
  color: white;
  position: fixed;
  width: 100%;
  padding-block: 10px;
  z-index: 1000;

  opacity: 0;
  animation: ${fadeInAnimation} 0.5s ease-in-out forwards;
`



const GoogleSearchResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  padding-bottom: 10px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.5s ease-in-out forwards;
`


const GoogleSearchRes = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);


    > div {
        display: flex;
        flex-direction: column;
        width: 700px;
        margin-left: 30px;
        margin-right: 20px;
    }
`

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 260px;
  border: none;
  border-radius: 3px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  position: absolute;
  top: 35px;
  z-index: 100000;
  background-color: white;
  padding: 10px;
  align-items: start;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h4 {
    font-family: 'Quicksand';
    font-weight: bold;
  }

  > p {
    font-weight: 400;
    font-family: 'Quicksand';
    margin-bottom: 6px;
  }

  > .top {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;

    > h4 {
    font-family: 'Quicksand';
    font-weight: bold;
    }

    > input {
      border: 1px solid lightgray;
      margin-left: 10px;
      width: 120px;
      outline: none !important;
      font-size: 23px;
      padding: 5px !important;
    }
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    /* gap: 10px; */
    /* margin-top: 20px; */

    > button {
      padding: 5px 10px;
      border-radius: 1px;
      background-color: dodgerblue;
      color: white;
      transition: background-color 0.3s ease-in-out;
      border: 1px solid lightgray;
      cursor: pointer;

      &:hover {
        color: #065eb7;
        background-color: white;
      }
    }
  }

  > .pre {
    display: flex;
    flex-direction: row;
    align-items: center;
    width: 100%;
    cursor: pointer;
    transition: background-color 0.3s ease-in-out;
    padding: 5px;

    &:hover {
      background-color: #d3d3d341;
    }

    > h4 {
      font-weight: 300;
      font-family: 'Quicksand';
    }

    > p {
      margin-left: auto;
      font-family: 'Quicksand';

    }
  }


  > .custom {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 20px;
    gap: 10px;

    > h4 {
      font-weight: 300;
      align-self: start;
    }

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;
      gap: 6px;


      > input {
        border: 1px solid lightgray;
        border-radius: 5px;
        outline: none;
        padding: 3px 6px;
        width: 70px;

        &::-webkit-inner-spin-button,
        &::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
      }
    }
  }


  > .diff-btn {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
      margin-top: 10px;

      > button {
        padding: 5px 10px;
        border-radius: 1px;
        background-color: dodgerblue;
        color: white;
        transition: background-color 0.3s ease-in-out;
        border: 1px solid lightgray;
        cursor: pointer;

        &:hover {
          color: #065eb7;
          background-color: white;
        }
      }
  }
`


const CompetitionResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 2;
  margin-bottom: 70px;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 10px;
`


const CompetitorContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    background-color: ${({ selected }) => selected ? 'rgb(223, 239, 255)' : ''};
    align-items: center;

    > p, div > div > span {
      font-family: 'Quicksand';
    }


    > div {
        display: flex;
        flex-direction: column;
        width: 400px;
        margin-left: 30px;
    }
`

const ChartContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px;
  margin: 20px;
  overflow-x: hidden;
  overflow-y: hidden;
  background-color: white;
  border-radius: 2px;
  z-index: 10;
  margin-bottom: 70px;
  font-family: 'Roboto Flex';
  height: 410px;
  background-color: transparent;
  width: 95%;
  gap: 35px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.7s ease-in-out forwards;

  > div {
    display: flex;
    flex-direction: column;
    gap: 20px;
    justify-content: space-between;
    height: 100%;
    border-radius: 3px;
  }
`


const CardHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;

  > h3 {
    font-family: 'Quicksand';
    font-weight: normal;
  }
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 400px;
  width: 100%;
  background-color: white;
  align-items: center;
  padding: 10px;
  border-radius: 3px;
`


const DataContainer = styled.div`
  max-height: 460px; 
  overflow-y: scroll;
  border-radius: 2px;
  /* margin: 20px; */
  margin-top: 16px;
`


const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${fadeInAnimation} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`